import axios from 'axios';

export function getAllCountries() {
  return axios.get('/api/v1/countries');
}

export function getAllCitiesByCountry(countryId) {
  return axios.get(`/api/v1/cities/country/${countryId}`);
}
